<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">人工處理紀錄</div>
      <div style="margin-top: 2rem">
        <commonQueryInput
          :inputItems="workInputItems"
          v-model:getValue="workInputVal"
        ></commonQueryInput>
        <commonQueryInput
          :inputItems="multiInputItems"
          v-model:getValue="multiInputVal"
        ></commonQueryInput>
      </div>
      <div class="mt-4">
        <div v-if="manualRecordOrderData.length != 0" class="text-start mb-3">
          <template v-for="n in manualRecordOrderData.length" :keys="n">
            <button
              class="btn manualRecord-order-button me-2 mb-1"
              :class="{ active: buttonSelect == n }"
              @click="buttonSelect = n"
            >
              {{ n }}
            </button>
          </template>
        </div>
        <commonTable
          :fields="manualRecordFields"
          :items="manualRecordItems"
          :theme="'green'"
          stickyHeader="450px"
        >
          <template #cell(totalWeight)="data">
            {{ data.value.toLocaleString("en-US") }}
          </template>
          <template #cell(modifiedDate)="data">
            <template v-if="data.value == '' || data.value == null">-</template>
            <template v-else>{{ data.value }}</template>
          </template>
          <template #cell(changeUser)="data">
            <template v-if="data.value == '' || data.value == null">-</template>
            <template v-else>{{ data.value }}</template>
          </template>
          <template #cell(reason)="data">
            <template v-if="data.value == '' || data.value == null">-</template>
            <template v-else>{{ data.value }}</template>
          </template>
          <template #cell(detail)="data">
            <button
              type="button"
              class="btn manualRecord-button"
              style="
                height: 21px;
                line-height: normal;
                line-height: 13px;
                background-color: #4b8c80;
                border-color: #4b8c80;
              "
              @click="query_detailData(...data.value)"
            >
              明細
            </button>
          </template>
        </commonTable>
      </div>
    </div>
    <div class="col-1"></div>
  </div>
  <commonModal :modalShow="modalShow" :size="'xl'">
    <template v-slot:modalheader>
      <button type="button" class="close" @click="modalShow = false">×</button>
    </template>
    <template v-slot:default>
      <div class="px-3">
        <workorderTable
          :workorderItem="detailData.workorderItem"
          class="mb-3"
        />
        <orderDataTemplate />
      </div>
    </template>
  </commonModal>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import commonTable from "@/components/commonTable.vue";
import commonModal from "@/components/commonModal.vue";
import workorderTable from "@/components/orderManagement/orderDataTemplate/table/workorderTable.vue";
import orderDataTemplate from "@/components/orderManagement/orderDataTemplate.vue";
import { computed, inject, provide, ref, watch } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    commonQueryInput,
    commonTable,
    commonModal,
    workorderTable,
    orderDataTemplate,
  },
  setup() {
    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const oper = computed(() => store.getters["selectOptions/get_orgProcess"]);

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const path = inject("path");
    const workInputVal = ref();
    const workInputItems = ref([
      {
        key: "workCode",
        label: "派工單號",
        type: "text",
        checkEmpty: true,
      },
      {
        key: "oper",
        label: "製程",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇製程 --",
        options: oper,
      },
    ]);
    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "date",
        label: "日期",
        type: "dateBetween", // date/dateBetween/text/select/
      },
      {
        key: "changeUserCode",
        label: "異動人員工號",
        type: "text",
      },
    ]);

    //人工處理紀錄資訊
    const manualRecordOrderData = ref([]);
    const manualRecordFields = [
      {
        key: "workCode",
        label: "工單",
        thStyle: {
          "min-width": "120px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "operName",
        label: "製程",
        thStyle: {
          "min-width": "120px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "totalWeight",
        label: "生產總重(KG)",
        thStyle: {
          "min-width": "130px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "modifiedDate",
        label: "異動日期",
        thStyle: {
          "min-width": "175px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "changeUser",
        label: "異動人員",
        thStyle: {
          "min-width": "120px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "reason",
        label: "異動原因",
        thStyle: {
          "min-width": "200px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "detail",
        label: "明細",
        thStyle: {
          "min-width": "90px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const manualRecordItems = ref([]);

    const buttonSelect = ref(0);

    const modalShow = ref();

    const detailData = ref({
      operID: "",
      workCode: "",
      sourceData: [],
      workorderItem: [],
    });
    const query_detailData = (
      workCode,
      oper,
      deviceName,
      workEndTime,
      transTimes
    ) => {
      detailData.value = {
        operID: "",
        workCode: "",
        sourceData: [],
        workorderItem: [],
      };
      console.log(workCode, oper, deviceName, workEndTime, transTimes);
      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = path.value;
      console.log(path.value);
      params["methods"] = "POST";
      params["whichFunction"] = "queryManualRecordUserData";
      params["work_code"] = workCode;
      params["project_id"] = oper;
      params["device_name"] = deviceName;
      params["work_end_time"] = workEndTime;
      params["trans_times"] = transTimes;
      params["whichFunction"] = "manualRecordDetail";

      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        methods.triggerLoadingBar();
        if (response == "ok") {
          let operID = result.QueryTableData.processSelected;
          let workorderItem = result.QueryTableData.workorderItem;
          let sourceData = result.QueryTableData.sourceData;
          if (operID == 5) {
            sourceData.forEach((data) => {
              data.wireItem.push({
                index: "",
                in_scroll_no: "",
                scroll_no: "",
                orgScroll_no: "",
                code: "",
                chinese_name: "",
                furnaceCode: "",
                in_consumption: "",
                consumption: "",
                orgConsumption: "",
                org_code: "",
                reason: [],
                del: "",
              });
              data.runcardItem.push({
                index: "",
                in_runcard_code: "",
                runcard_code: "",
                orgRuncard_code: "",
                in_furnace_code: "",
                furnace_code: "",
                orgFurnace_code: "",
                in_screw_weight: "",
                screw_weight: "",
                orgScrew_weight: "",
                in_bucket_weight: "",
                bucket_weight: "",
                orgBucket_weight: "",
                reason: [],
                del: "",
              });
            });
          } else if (operID == 6) {
            sourceData.forEach((data) => {
              data.runcardItem.push({
                index: "",
                in_runcard_code: "",
                runcard_code: "",
                orgRuncard_code: "",
                in_furnace_code: "",
                furnace_code: "",
                orgFurnace_code: "",
                in_screw_weight: "",
                screw_weight: "",
                orgScrew_weight: "",
                in_bucket_weight: "",
                bucket_weight: "",
                orgBucket_weight: "",
                reason: [],
                del: "",
              });
            });
          } else if (operID == 7) {
            sourceData.forEach((data) => {
              data.runcardItem.push({
                index: "",
                in_runcard_code: "",
                runcard_code: "",
                orgRuncard_code: "",
                in_furnace_code: "",
                furnace_code: "",
                orgFurnace_code: "",
                in_screw_weight: "",
                screw_weight: "",
                orgScrew_weight: "",
                in_bucket_weight: "",
                bucket_weight: "",
                orgBucket_weight: "",
                reason: [],
                del: "",
              });
            });
          }
          if (sourceData.length == 0) {
            methods.setTimeoutAlert("查無資料");
            return;
          }
          detailData.value = {
            operID: operID,
            workCode: workCode,
            sourceData: sourceData,
            workorderItem: workorderItem,
          };
          modalShow.value = true;
        } else {
          methods.setTimeoutAlert(response);
        }
      });
    };

    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      workInputVal,
      (newValue) => {
        buttonSelect.value = 0;
        methods.triggerLoadingBar();
        let params = {};
        params["webPage"] =
          sideNavPath.value.length != 0
            ? sideNavPath.value[sideNavPath.value.length - 1]
            : null;
        params["user"] = loginData.value.account;
        params["vuePage"] = path.value;
        console.log(path.value);
        params["methods"] = "POST";
        params["whichFunction"] = "queryManualRecordData";
        params["workCode"] = newValue["workCode"];
        params["oper"] = newValue["oper"];

        methods.axiosAction(params).then(() => {
          console.log(axiosResult.value);
          let result = axiosResult.value;
          let response = result.Response;
          if (response == "ok") {
            let queryTableData = result.QueryTableData;
            manualRecordOrderData.value = queryTableData;
            if (manualRecordOrderData.value.length == 0) {
              methods.setTimeoutAlert("查無資料");
              buttonSelect.value = 0;
            } else {
              buttonSelect.value = 1;
            }
          } else {
            manualRecordOrderData.value = [];
            manualRecordItems.value = [];
            methods.setTimeoutAlert(response);
          }
          methods.triggerLoadingBar();
        });
      },
      { deep: true }
    );
    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        methods.triggerLoadingBar();
        manualRecordOrderData.value = [];
        let params = {};
        params["webPage"] =
          sideNavPath.value.length != 0
            ? sideNavPath.value[sideNavPath.value.length - 1]
            : null;
        params["user"] = loginData.value.account;
        params["vuePage"] = path.value;
        console.log(path.value);
        params["methods"] = "POST";
        params["whichFunction"] = "queryManualRecordUserData";
        params["startTime"] = newValue["date"]["startDate"] + " 00:00:00";
        params["endTime"] = newValue["date"]["endDate"] + " 23:59:59";
        newValue["changeUserCode"] != undefined
          ? (params["changeUserCode"] = newValue["changeUserCode"])
          : "";

        methods.axiosAction(params).then(() => {
          console.log(axiosResult.value);
          let result = axiosResult.value;
          let response = result.Response;
          if (response == "ok") {
            let queryTableData = result.QueryTableData;
            manualRecordItems.value = queryTableData.manualRecordData;
            if (manualRecordItems.value.length == 0) {
              methods.setTimeoutAlert("查無資料");
            }
          } else {
            manualRecordItems.value = [];
            methods.setTimeoutAlert(response);
          }
          methods.triggerLoadingBar();
        });
      },
      { deep: true }
    );
    watch(buttonSelect, (newValue) => {
      manualRecordItems.value = manualRecordOrderData.value[newValue - 1];
    });

    provide("orderManagementDetailData", detailData);
    return {
      workInputVal,
      workInputItems,
      multiInputVal,
      multiInputItems,
      manualRecordOrderData,
      manualRecordFields,
      manualRecordItems,
      buttonSelect,
      modalShow,
      detailData,
      query_detailData,
    };
  },
};
</script>

<style scoped>
.manualRecord-button {
  width: 53px;
  height: 22px;
  line-height: 22px;
  padding: 0px;
  background-color: var(--main-bg-color);
  color: var(--main-font-color);
  border: 0px;
}

.manualRecord-button:hover {
  color: var(--main-font-color);
}

.manualRecord-order-button {
  height: 2rem;
  padding: 0;
  width: 4.25rem;
  color: var(--main-font-color);
  background-color: var(--main-status-secondary-color);
  border-color: var(--main-status-secondary-color);
}

.manualRecord-order-button:hover {
  color: var(--main-font-color);
}

.manualRecord-order-button.active {
  background-color: var(--main-bg-color);
  border-color: var(--main-bg-color);
}
</style>